export default "/images/vendor/flag-icon-css/flags/1x1/fk.svg?fe8e733a5a44d9626de2b2d6ab9084c5";